import React from 'react';
import { Box, Typography } from '@mui/material';
import { breakpoints } from '@/themes/themeOverrides/Breakpoints';
import { Palette } from '@/themes/themeOverrides/Palette';

const DeviceDetailsStatsBox = ({ title, icon, children, sx = {}, ...rest }) => (
    <Box
        sx={{
            backgroundColor: Palette.gray.gray75,
            padding: '32px',
            borderRadius: '16px',
            flex: 1,
            ...sx,
            [`@media (max-width: ${breakpoints.values.md}px)`]: {
                padding: '24px',
            },
        }}
        {...rest}
    >
        <Typography
            variant='caption'
            sx={{
                fontSize: '16px',
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                mb: 2,
                [`@media (max-width: ${breakpoints.values.md}px)`]: {
                    fontSize: '14px',
                    lineHeight: '20px',
                    marginBottom: '4px',
                },
            }}
        >
            {icon && (
                <Box
                    component='span'
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        mr: 1,
                        [`@media (max-width: ${breakpoints.values.md}px)`]: {
                            marginBottom: '20px',
                        },
                    }}
                >
                    {icon}
                </Box>
            )}
            {title}
        </Typography>
        {children}
    </Box>
);

export default DeviceDetailsStatsBox;
